/**
 * @Author: v_jppjpeng
 * @Date: 2023-5-11 10:02:25
 * @Explain: 设置 - 用户管理
 */
import http from '../http';

const MODEL = '/account';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/get-game-account-roles`, data);
  },
  // 详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/get-account-info`, data);
  },
  // 新增用户 - 发起邀请
  onInvite(data: Record<any, any>) {
    return http.post(`/invite/invite-account`, data);
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update-account-role`, data);
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete-account-role`, data);
  },
  // 重新邀请
  onReinvite(data: { email: string }) {
    return http.post(`/invite/reinvite-account`, data);
  },
  // 查询 当前登录用户信息
  getAccountInfo(data: Record<any, any>) {
    return http.post(`${MODEL}/query-account-info`, data);
  },
  // 设置是否新用户
  setNewUser() {
    return http.post(`${MODEL}/set-register-pop`, {});
  },
  // 编辑 个人资料
  onEditMyProfiles(data: Record<any, any>) {
    return http.post(`${MODEL}/save-account-profiles`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 设置双因素 - 状态
  setTwoFactorState(data: Record<any, any>) {
    return http.post(`${MODEL}/set_two_factor`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 检查双因素验证码
  checkTwoFactorCode(data: Record<any, any>) {
    return http.post(`${MODEL}/check_code`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 保存用户状态-区域管理
  saveFirstStatus(data: { regionGroupIsViewed: boolean }) {
    return http.post(`${MODEL}/save_is_viewed`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
